import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const ClosedEyeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  // parse width and height from props as number
  let width = props.width ?? props.size ?? 24;
  if (typeof width === "string") {
    width = parseInt(width);
  }
  let height = props.height ?? props.size ?? width / 2;
  if (typeof height === "string") {
    height = parseInt(height);
  }

  return (
    <IconBase
      width={width}
      height={height}
      viewBox="0 0 24 12"
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M19 3.99988L21 7.44434"
              stroke={color}
              strokeWidth="1.3"
              strokeLinecap="square"
              strokeLinejoin="round"
              fill="transparent"
            />
            <path
              d="M13.7329 5.62244L14.4721 9.81816"
              stroke={color}
              strokeWidth="1.3"
              strokeLinecap="square"
              strokeLinejoin="round"
              fill="transparent"
            />
            <path
              d="M8.26703 5.61206L7.52783 9.8182"
              stroke={color}
              strokeWidth="1.3"
              strokeLinecap="square"
              strokeLinejoin="round"
              fill="transparent"
            />
            <path
              d="M3 3.99988L1 7.46517"
              stroke={color}
              strokeWidth="1.3"
              strokeLinecap="square"
              strokeLinejoin="round"
              fill="transparent"
            />
            <path
              d="M1.01025 1C2.75934 3.16554 5.966 5.90369 11.005 5.90369C16.0441 5.90369 19.2507 3.16554 20.9998 1"
              stroke={color}
              strokeWidth="1.3"
              strokeLinecap="square"
              strokeLinejoin="round"
              fill="transparent"
            />
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

ClosedEyeIcon.displayName = "ClosedEyeIcon";

export { ClosedEyeIcon };

export const CimClosedEyeIcon = ({
  color = "#1e1e1e",
  width = 13,
  height = 6,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 6" fill="none">
      <line x1="7.9153" y1="2.90684" x2="8.52786" y2="4.8382" stroke={color} strokeWidth="0.8" strokeLinecap="round" />
      <line
        x1="10.6896"
        y1="1.45665"
        x2="12.0045"
        y2="2.83486"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <line
        x1="0.4"
        y1="-0.4"
        x2="2.42618"
        y2="-0.4"
        transform="matrix(-0.302324 0.953205 0.953205 0.302324 4.99121 2.64648)"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <line
        x1="0.4"
        y1="-0.4"
        x2="2.30488"
        y2="-0.4"
        transform="matrix(-0.690304 0.723519 0.723519 0.690304 2.28027 1.44336)"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M0.990234 0.400391C1.92868 1.94544 3.87737 3.00724 6.12916 3.00724C8.38095 3.00724 10.3296 1.94544 11.2681 0.400391"
        stroke={color}
        strokeWidth="0.8"
        strokeLinecap="round"
      />
      <path
        d="M0.990234 0.400391C1.92868 1.94544 3.87737 3.00724 6.12916 3.00724C8.38095 3.00724 10.3296 1.94544 11.2681 0.400391"
        stroke={color}
        strokeOpacity="0.2"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </svg>
  );
};
